import React from 'react';
import Utilities from '@util/Utilities';
import {
	findSentimentTextColorClass
} from '@app/site/secured/review-manager/fragment/property-overview/component/SentimentColors';
import GroupReviewsStateForPeriod from '@app/model/review/state/GroupReviewsStateForPeriod';
import { useCompanyHotels } from '@app/site/secured/rateshopper/rates/provider/useCompanyHotels';


const ReviewsGroupPropertyPerformanceFragment: React.FunctionComponent<{
	groupReviewsState: GroupReviewsStateForPeriod
}> = ({ groupReviewsState }) => {

	const { companyHotels } = useCompanyHotels();
	const mainHotelStates = groupReviewsState.mainHotelStates();

	return <div className="col-span-4">
			<div className="px-3 mb-1">
				<h2 className="text-base font-semibold text-gray-900">Property Performance</h2>
			</div>
			<div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
				<div className="overflow-x-auto overflow-y-auto">
					<div className="inline-block min-w-full align-middle">
						<table className="min-w-full divide-y divide-gray-300">
							<thead className="bg-gray-50">
							<tr>
								<th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Property</th>
								<th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Location</th>
								<th scope="col"
										className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-right">Score
								</th>
								<th scope="col"
										className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-right">Response Rate
								</th>
								<th scope="col"
										className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-right">Reviews
								</th>
								<th scope="col"
										className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-center">Trend
								</th>
							</tr>
							</thead>
							<tbody className="bg-white divide-y divide-gray-200">
							{mainHotelStates.map((hotelReviewsState) => {
								const companyHotel = companyHotels.find(ch => ch.mainHotelId === hotelReviewsState.hotelId);

								return <tr key={hotelReviewsState.hotelId}>
								<td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900 sm:pl-3">
									{hotelReviewsState.hotelName}
								</td>
								<td className="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500">{companyHotel?.mainHotelLocation?.city ?? '-'}</td>
								<td className="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500 sm:text-right">
									<span
										className={`font-bold ${findSentimentTextColorClass(hotelReviewsState.statistics.score * 100)}`}>{Utilities.formatDouble(hotelReviewsState.statistics.score, 1)}</span>
								</td>
								<td
									className="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500 sm:text-right">{Utilities.formatDouble(hotelReviewsState.statistics.responseRate * 100, 0)}%
								</td>
								<td
									className="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500 sm:text-right">{hotelReviewsState.statistics.numberOfReviews}</td>
								<td className="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500 sm:text-center">
									<div className="flex justify-center">
									</div>
								</td>
							</tr>;
							})}
							</tbody>
						</table>
					</div>
				</div>
			</div>
	</div>;
};

export default ReviewsGroupPropertyPerformanceFragment;
